const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-js';

function isGoogleMapsReady(): boolean {
  const mapsApi = (window as any).google;
  return !!(mapsApi && mapsApi.maps && mapsApi.maps.places);
}

export function loadGoogleMapsScript(apiKey: string): Promise<void> {
  if (isGoogleMapsReady()) {
    return Promise.resolve();
  }

  if (!apiKey) {
    console.warn(
      'Google Maps API key is not configured. Set googleMapsApiKey in the environment file.'
    );
    return Promise.resolve();
  }

  const existingScript = document.getElementById(
    GOOGLE_MAPS_SCRIPT_ID
  ) as HTMLScriptElement | null;

  if (existingScript) {
    return new Promise((resolve, reject) => {
      if (isGoogleMapsReady()) {
        resolve();
        return;
      }
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener(
        'error',
        () => reject(new Error('Failed to load Google Maps')),
        { once: true }
      );
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = GOOGLE_MAPS_SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      apiKey
    )}&libraries=places&v=weekly`;
    script.async = true;
    script.defer = true;
    script.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error('Failed to load Google Maps'));
    document.head.appendChild(script);
  });
}

export function googleMapsInitializer(apiKey: string): () => Promise<void> {
  return () =>
    loadGoogleMapsScript(apiKey).catch((error) => {
      console.error(error);
    });
}
